import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import List from "./Notification/NotificationList"

class Notification extends Component {

    render() {
        let notifications = app.routes.find(x => x.name === 'notifications');
        return (
            <Fragment>
                <Switch>
                    <Route exact path="/app/notifications" component={List} />
                    {notifications.routes.map((route, key) => {
                        return <Route
                            path={`${app.path}${notifications.path}${route.path}`}
                            meta={route.meta}
                            component={route.component}
                            key={key}
                        />;
                    })}
                </Switch>
            </Fragment>

        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Notification);


// WEBPACK FOOTER //
// ./src/components/App/Views/Notification.js